import {useMemo} from "react";
import {useDataSource} from "src/core/data-sources/decorators/withData";
import ShopPaymentOptionsDataSource from "../../shops/data-sources/shopPaymentOptions";
import useFeatureToggles from "src/core/common/hooks/useFeatureToggles";
import useAuthentication from "src/core/authentication/hooks/useAuthentication";

export default function usePaymentOptions() {
  const [, Authentication] = useAuthentication();
  const toggles = useFeatureToggles();
  const {data: paymentOptions, meta} = useDataSource(
    {},
    {
      dataSource: paymentOptionsDataSource,
    }
  );

  return useMemo(() => {
    if (!paymentOptions || paymentOptions.getElements().length === 0) {
      return [[], meta];
    }

    if (toggles.isGuestCheckoutActive(Authentication.isLoggedIn())) {
      return [
        paymentOptions
          .getElements()
          .filter(paymentOption => paymentOption.supportsGuestCheckout()),
        meta,
      ];
    }

    return [paymentOptions.getElements(), meta];
  }, [paymentOptions]);
}

const paymentOptionsDataSource = new ShopPaymentOptionsDataSource();
